import { Avatar, Box, Menu, SkeletonText } from '@volue/wave-react';
import React from 'react';

import { useActions, useAppState } from '@/overmind';
import { isUserSignedInToVolueIdentity } from '@/overmind/machines';

export function User() {
  const auth = useAppState().auth;
  const user = isUserSignedInToVolueIdentity(auth) ? auth.user : undefined;
  const logOut = useActions().loggedOut;
  return (
    <Menu>
      <Menu.Trigger className="sidebarNav-user sidebarNav-item txtTruncate fg1 ofH sidebarNav-user">
        <Avatar of={user?.name ?? ''}>
          <Avatar.Initials />
        </Avatar>
        <SkeletonText width="15ch" isLoaded={!!user} className="txtTruncate">
          <span className="sidebarNav-userName txtTruncate">{user?.name}</span>
        </SkeletonText>
      </Menu.Trigger>
      <Menu.Content className="parentZIndex1100">
        <Box className="pHm pVs">
          <Box>{user?.name}</Box>
          <Box>{user?.preferredUsername}</Box>
        </Box>
        <Menu.Separator />
        <Menu.Item intent="danger" onSelect={() => logOut()}>
          {'Log Out'}
        </Menu.Item>
      </Menu.Content>
    </Menu>
  );
}
